










import { defineComponent, PropType, ref, useFetch } from '@nuxtjs/composition-api';
import ProductListItemComponent from '~/components/pages/Product/ProductListItem.vue';
import { useStore } from '~/composables/useStore';
import { nonNullable } from '~/utils';
import { DynamicPartsWineIntro } from '~/types/modules/contents';
import { ProductListItem } from '~/types/modules/product';

export default defineComponent({
  components: {
    ProductListItemComponent,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsWineIntro>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const productInfo = ref<ProductListItem>();
    const targetVariantCodes = ref<string[]>([]);

    const fetchProduct = async () => {
      // 親商品の情報を取得
      try {
        const { items } = await store.dispatch('modules/product/fetchProducts', {
          q: `mst:product AND product_code_s: ${props.item.product_code} NOT display_flag_i: 0`,
        });
        productInfo.value = items[0];
      } catch {
        // 何もしない（トルツメ）
      }
      if (!productInfo.value) return;

      const selectedVariantCodes = props.item.product_variant_codes.filter(nonNullable);
      // 子商品未指定の場合は子商品スキップ
      if (selectedVariantCodes.length === 0) {
        return;
      }

      // 商品コードが完全一致かつ表示フラグtrueの子商品のみ抽出する
      const targetChildren: string[] = [];
      productInfo.value.children.forEach((child) => {
        // 生産年_表示価格_新着フラグ_定価_在庫数_販売開始日時_販売終了日時_最高得点の評価誌種別_最高得点の評価誌ポイント_表示フラグ_子商品コード
        const childElementArray = child.split('_');
        const childProductCode = childElementArray.splice(10).join('_');
        const displayFlag = Number(childElementArray[9]);
        if (selectedVariantCodes.includes(childProductCode) && displayFlag) {
          targetChildren.push(child);
          targetVariantCodes.value.push(childProductCode);
        }
      });
      // コードが完全一致の子商品がない場合は、
      // productInfo.childrenそのまま渡す、targetVariantCodesは空のまま渡す
      if (targetChildren.length === 0) return;

      productInfo.value.children = targetChildren;
    };

    useFetch(async () => {
      await fetchProduct();
    });

    return { productInfo, targetVariantCodes };
  },
});
